<template>
  <div class="account paymentpaywell">
    <div v-if="checkQrcode.hasQrcode">
      <div v-if="!checkQrcode.qrcode.includes('<svg')">
        <div class="m-t-0 m-b-10 text-center">
          กรุณาโอนเงินพร้อมกับอัพโหลดสลิปที่ด้านล่างภายใน 10 นาทีเท่านั้น<br />
          หากไม่สามารถทำรายการดังกล่าวได้ภายในระยะเวลาที่กำหนด<br />
          <b>
            ***
            บริษัทขอสงวนสิทธิ์ไม่รับผิดชอบต่อความเสียหายที่เกิดขึ้นจากการทำรายการไม่ถูกต้องตามเงื่อนไขของระบบ
            ***
          </b>
        </div>
        <div class="iframe-container">
          <iframe :src="checkQrcode.qrcode" frameborder="0" />
        </div>
      </div>
      <div v-else>
        <div class="columns is-mobile">
          <div class="column is-12 is-two-third-mobile">
            <div class="m-b-20 text-center">
              <b>Payment</b>
            </div>
            <div
              class="qrcode-preview margin-auto"
              v-html="checkQrcode.qrcode"
            ></div>
          </div>
        </div>
        <div class="text-center">
          <b
            >{{ $t('modals.deposit.amountPla') }}
            {{ checkQrcode.amount }}
            {{ $t('modals.transfer.bahtTxt') }}</b
          >
        </div>
        <div class="field m-t-20 text-center">
          <div>{{ $t('modals.deposit.qr1Txt') }}</div>
          <div>
            {{ $t('modals.deposit.qr2Txt') }} {{ timeInterval }}
            {{ $t('modals.deposit.qr3Txt') }}
          </div>
          <div class="m-t-20 text-center">
            <b>{{ $t('modals.deposit.qr4Txt') }}</b>
          </div>
          <div class="m-t-10">
            <button
              type="button"
              class="button small is-danger m-l-10"
              @click="clearQrcode"
            >
              {{ $t('modals.deposit.cancelBtn') }}
            </button>
            <button
              type="button"
              class="button small is-success m-l-10"
              @click="scanQrcode"
            >
              {{ $t('modals.deposit.transferBtn') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="columns is-mobile">
        <div class="column is-12 is-two-third-mobile">
          <div class="m-b-20 text-center">
            <b>Payment</b>
          </div>
          <div class="qrcode-preview margin-auto">
            <span>QR code</span>
          </div>
        </div>
      </div>
      <div class="m-t-20 text-center">
        {{ $t('modals.deposit.qrAmountTxt') }}
      </div>
      <div class="m-t-10">
        {{ $t('modals.deposit.qrCondition1Txt') }}<br />
        {{ $t('modals.deposit.qrCondition2Txt') }}<br />
        {{ $t('modals.deposit.qrCondition3Txt') }}<br /><br />
        {{ $t('modals.deposit.qrConditionWw1Txt') }}<br />
        {{ $t('modals.deposit.qrConditionWw2Txt') }}
      </div>
      <div class="m-t-15 text-center big">
        <b>
          ***
          {{
            $t('modals.deposit.qrConditionWw3Txt', {
              minDeposit: this.minDeposit
            })
          }}
          ***
        </b>
      </div>
      <div class="field display-flex m-t-20 justify-center">
        <div class="control has-icons-left">
          <input
            v-model="qrcodeAmount"
            type="number"
            :placeholder="$t('modals.deposit.amountPla')"
            class="input text-center"
          />
          <span class="icon is-left">
            <i class="fas fa-coins"></i>
          </span>
        </div>
        <b-button
          class="button small is-success m-l-10"
          @click="createQrcode"
          :loading="isQrCreating"
          :disabled="qrcodeAmount < minDeposit"
        >
          {{ $t('modals.deposit.qrCreateBtn') }}
        </b-button>
      </div>
      <div class="m-t-10 text-center">
        <b-button
          class="no-radius"
          v-for="(amount, index) in amountList"
          :key="index"
          outlined
          @click="selectQrcodeAmount(amount)"
        >
          {{ amount.toLocaleString() }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import i18n from '@/language'

import apiVerifyQrcode from '@/api/verify.qrcode'

export default {
  name: 'ModalDeposit',
  props: {
    depositAccount: {
      type: Object
    },
    refreshQrcode: {
      type: Object
    }
  },
  watch: {
    'refreshQrcode.PAYWELL': {
      handler(val) {
        if (val) {
          this.getQrcode()
          this.$emit('clearRefreshQrcode', this.depositAccount.bankCode)
        }
      }
    }
  },
  data() {
    return {
      checkQrcode: {
        qrcodeId: '',
        hasQrcode: false,
        qrcode: '',
        amount: 0,
        expireIn: ''
      },
      qrcodeAmount: null,
      amountList: [100, 200, 300, 500, 1000],
      interval: null,
      timeInterval: null,
      minDeposit: 100,
      isQrCreating: false
    }
  },
  created() {
    this.getQrcode()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    onCopy(e) {
      this.$buefy.toast.open({
        message: `Copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    },
    async getQrcode() {
      const data = await apiVerifyQrcode.getQrcode('PAYWELL')
      this.checkQrcode = data

      if (data && data.expireIn) this.countdown(this.checkQrcode.expireIn)
    },
    async scanQrcode() {
      this.$buefy.toast.open({
        message: i18n.t('modals.deposit.refreshAmountMsg'),
        type: 'is-success'
      })

      this.$emit('closeModal', null)
    },
    async createQrcode() {
      try {
        if (this.qrcodeAmount < 1) return

        this.isQrCreating = true

        const data = await apiVerifyQrcode.createQrcode('PAYWELL', {
          amount: this.qrcodeAmount
        })
        if (data.hasQrcode === false) {
          this.$buefy.toast.open({
            message: data.message,
            type: 'is-danger'
          })
        } else {
          this.checkQrcode = data
          if (data && data.expireIn) this.countdown(this.checkQrcode.expireIn)
        }

        this.$emit('updateRefreshQrcodeExcept', this.depositAccount.bankCode)
      } finally {
        this.isQrCreating = false
      }
    },
    async clearQrcode() {
      await apiVerifyQrcode.clearQrcode(this.checkQrcode.qrcodeId)
      this.checkQrcode = {
        qrcodeId: '',
        hasQrcode: false,
        qrcode: '',
        amount: 0,
        expireIn: ''
      }

      clearInterval(this.interval)
    },
    countdown(then) {
      this.interval = setInterval(() => {
        const now = new Date()
        const ms = moment(then).diff(moment(now))

        const d = moment.duration(ms)

        const minute = d.minutes() < 10 ? '0' + d.minutes() : d.minutes()
        const second = d.seconds() < 10 ? '0' + d.seconds() : d.seconds()

        this.timeInterval = `${minute}:${second}`

        if (this.timeInterval === '00:00') {
          this.checkQrcode.hasQrcode = false

          clearInterval(this.interval)
        }
      }, 1000)
    },
    selectQrcodeAmount(amount) {
      this.qrcodeAmount = amount
    }
  }
}
</script>

<style scoped lang="scss">
.no-radius {
  border-radius: 4px;
  padding: 2px 8px;
  margin: 3px 3px;
  font-weight: 400;
  font-size: 14px;
}

.margin-auto {
  margin: auto;
}

.iframe-container {
  width: 100%;
  height: 750px;
  overflow: hidden;
}

.iframe-container iframe {
  width: 125%;
  height: 125%;

  border: 0;

  transform: scale(0.8);
  transform-origin: top left;

  max-width: 125% !important;
}
</style>
